import React from "react";
import { string } from "prop-types";

import "./page-title.m.css";

const PageTitle = ({ children, ...props }) => {
  return (
    <h1 styleName="page-title" {...props}>
      {children}
    </h1>
  );
};

PageTitle.propTypes = {
  children: string.isRequired
};

export default PageTitle;